import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes, FontWeights } from '../../../types/common/types';

/**
 * @summary This is a wrapper that will make anything passed be style according to the values passed through fontWeight and fontSize props
 * @tag gz-title
 *
 * @slot - You can put some elements here
 */
@customElement('gz-title')
export class GzTitleWebComponent extends LitElement {
  static get styles() {
    return styles;
  }

  /**
   * Weight of the font, can be FontWeights.*, default is FontWeights.NORMAL
   */
  @property({ type: FontWeights, attribute: true, reflect: true })
  fontWeight: FontWeights = FontWeights.NORMAL;

  /**
   * Size of the font, can be FontSizes.*, default is FontSizes.BODY
   */
  @property({ type: FontSizes, attribute: true, reflect: true })
  fontSize: FontSizes = FontSizes.BODY;

  render() {
    return html` <slot></slot> `;
  }
}
